export default __webpack_public_path__ + "static/media/46.bf727b19.png";